// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4560dda0","150":"b6a7b07f","229":"421021a4","488":"7fe8d881"}[chunkId] + ".chunk.js";
};